/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_PROV_STEP_CRED_DETAIL = gql`
    query getProvenanceStepCred($gtinKey: String!, $credTxId: ID!) {
        getProvenanceStepCred(gtinKey: $gtinKey, credTxId: $credTxId) {
            data
        }
    }
`;
